export default __webpack_public_path__ + "ddb1f3b63e33585263e5905706d6ff6d.svg";